module.exports = __webpack_public_path__ + "img/bespoke70_24.906e663d.jpg";